import '../Sass/App.scss';
import React, { useState } from 'react';
import { Card } from './Card2';
import { Modify } from './Modify';
import { useDrop } from 'react-dnd';
import Dialog from '@mui/material/Dialog';

export function VirusCardGroup (props) {

    const [cardGroup, setCardGroup] = useState(props.cards)
    const [modalOpen, setModalOpen] = useState(false)
    const [cardInFocus, setCardInFocus] = useState({cardData: null, indexInSeries: null})
    const [modifyOpen, setModifyOpen] = useState(false)

    const cardWidth = props.cardWidth / 3.45
    const cardHeight = cardWidth * 0.45

    const [{ isOver }, dropRef] = useDrop({
        accept: ['viral-card'],
        drop: (item) => {
            const dragIndex = item.indexInSeries
            item.sendHandler(dragIndex, 1)
            addToHand(item.cardData, 0)
        },
        collect: (monitor) => ({
            isOver: monitor.isOver()
        })
    })

    function reorder(dragIndex, dropIndex) {
        const currentCardGroup = [...cardGroup]
        const updatedGroup = []
        currentCardGroup.forEach((card, index) => {
            if (dragIndex > dropIndex && dropIndex < index && index <= dragIndex) {
                index == (dropIndex + 1) ? updatedGroup[index] = currentCardGroup[dragIndex] : updatedGroup[index] = currentCardGroup[index-1]
            } else if (dragIndex < dropIndex && dropIndex >= index && index >= dragIndex) {
                index == dropIndex ? updatedGroup[index] = currentCardGroup[dragIndex] : updatedGroup[index] = currentCardGroup[index+1]
            } else {
                updatedGroup[index] = currentCardGroup[index]
            }
        })
        setCardGroup(updatedGroup)

    }

    function removeFromHand(dragIndex) {
        const newGroup = [
            ...cardGroup.slice(0,dragIndex),
            ...cardGroup.slice(dragIndex+1, cardGroup.length)
        ];
        setCardGroup(newGroup)
        setModalOpen(false)
    }

    function addToHand(card, dropIndex) {
        const newGroup = [
            ...cardGroup.slice(0, dropIndex+1), 
            card, 
            ...cardGroup.slice(dropIndex+1, cardGroup.length)
        ]       
        setCardGroup(newGroup)
    }

    function expandCard(cardData, indexInSeries) {
        setCardInFocus({ cardData: cardData, indexInSeries: indexInSeries })
        setModalOpen(true)
    }
    
    function modifyCard() {
        setModalOpen(false)
        setModifyOpen(true)
    }

    function changeCardData(position, newData) {
        const currentHand = [...props.cards]
        props.setCards([
            ...currentHand.slice(0,position),
            newData,
            ...currentHand.slice(position+1, currentHand.length)
        ])
        setModifyOpen(false)
    }

    return (
        <>
        <div style={{width: '100%', minHeight: cardHeight, zIndex: 1101}} ref={cardGroup.length > 0 ? null : dropRef}>
            { cardGroup.length > 0 ? cardGroup.map((card, index) =>
                <Card finalCard={index == cardGroup.length -1 ? true : false } currentHome={props.currentHome} clickHandler={expandCard} sendHandler={removeFromHand} reorderHandler={reorder} receiveHandler={addToHand} cardData={card} cardWidth={cardWidth} cardStyle='virusCard' key={index} indexInSeries={index} showQuantity={false} />
            ) : null }
        </div>
        <Dialog
            open={modalOpen}
            onClose={() => setModalOpen(false)}
            PaperProps={{sx: {bgcolor: 'transparent'}}}
            >
                <Card cardData={cardInFocus.cardData} indexInSeries={cardInFocus.indexInSeries} cardWidth={500} showQuantity={false} options={true} sendHandler={removeFromHand} modifyHandler={modifyCard} notDraggable />
                <button className="close-button" style={{right: 0, top: 0, zIndex: 2500}} onClick={() => setModalOpen(false)}>X</button>
        </Dialog>
        <Dialog
            open={modifyOpen}
            maxWidth='xl'
            fullWidth={true}
            onClose={() => setModifyOpen(false)}
            PaperProps={{sx: {bgcolor: 'black', border: 1, borderColor: 'white', padding: 3, color: 'white'}}}
            >
                <Modify cardData={cardInFocus.cardData} indexInSeries={cardInFocus.indexInSeries} changeHandler={changeCardData} setModifyOpen={setModifyOpen} />
        </Dialog>
        </>
    )

}